import React, { useState, useEffect, useCallback } from 'react';
import DataTables from 'components/dataTables';
import { UserAction } from 'redux/actions';
import { connect } from 'react-redux';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import noImage from 'assets/img/users/no-image.jpg';
import Avatar from 'components/Avatar';
import PageSpinner from 'components/PageSpinner';
import { Input,Button } from 'reactstrap';
import _ from "lodash";
import { Link } from 'react-router-dom';

const Followers = (props) => {

    let [filters, setFilters] = useState();
    const [keyword, setKeyword] = useState('');
    const [pagination, setPagination] = React.useState({
        page: 0,
        page_limit: 10,
    });
    const [order, setOrder] = React.useState({
        order_by: `created_at`,
        direction: 'desc'
    });


    useEffect(() => {
        setKeyword('');
        setOrder({
            order_by: `created_at`,
            direction: 'desc'
        });
        setPagination({
            page: 0,
            page_limit: 10,
        })
    }, [props.userId]);


    useEffect(() => {

        setFilters({
            user_id: props.userId,
            page: pagination.page,
            page_limit: pagination.page_limit,
            order_by: order.order_by,
            direction: order.direction,
            keyword: keyword
        })
    }, [pagination, order,props.userId]);

    useEffect(() => {
        filters && props.getFollowers(filters);
    }, [filters]);

    const handleChange = (event) => {
        setKeyword(event.target.value);
        debounce(event.target.value, filters);
    };

    const debounce = useCallback(
        _.debounce((searchVal, filters) => {
            setFilters({
                ...filters, 'keyword': searchVal
            })
        }, 1000),
        []
    );

    const profilePicture = (value) => {
        return (<Avatar src={(value) ? value : noImage} />);
    }
    const viewProfile = (id)=>{
        return <Link className={'view-profile-link'} to={`/user-profile/${id}`}><Button color="primary" className="border-0" >View Profile</Button></Link>;
    }

    const columns = () => {
        const cols = [
            
            { name: "avatar", label: "Profile Picture" },
            { name: "name", label: "Name" },
            { name: "username", label: "Username" },
            { name: "email", label: "Email" },
            { name: "phone", label: "Phone" },
            { name: "id", label: "id" }
        ];
        return cols.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    //display: (column.name === 'id') ? false : true,
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {

                        return (tableMeta.columnData.name === 'avatar') ? profilePicture(value) : 
                        (tableMeta.columnData.name === 'id')?viewProfile(value):value;
                    }
                }
            }
        })
    }

    const options = {
        textLabels: {
            body: {
                noMatch: props.isLoading ? <PageSpinner style={{ height: '10vh' }} /> : 'Sorry, no matching records found',
            }
        },
        tableId: 'datatable',
        filterType: 'checkbox',
        search: false,
        responsive: "simple",
        filter: false,
        download: false,
        print: false,
        selectableRows: 'none',
        viewColumns: false,
        count: (props.totalCount) ? props.totalCount : 0,
        serverSide: (props.serverSide !== undefined) ? props.serverSide : true,
        page: pagination.page,
        rowsPerPage: pagination.page_limit,
        onColumnSortChange: (changedColumn) => {
            setOrder({
                order_by: changedColumn,
                direction: (order.direction === 'asc') ? 'desc' : 'asc'
            })
        },
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPagination({
                        page_limit: pagination.page_limit,
                        page: tableState.page
                    })
                    break;
                case 'changeRowsPerPage':
                    setPagination({
                        page_limit: tableState.rowsPerPage,
                        page: 0,
                    })
                    break;
                default:
                    break
            }
        }
    };

    return (
        <div>

            <Input
                type="text"
                name="query"
                id="query"
                onChange={handleChange}
                autoComplete={'off'}
                value={keyword}
                placeholder={'Search by name, username or email'}
                style={{ width: 350, marginBottom: 10 }}
            />
            <DataTables data={(props.data) ? props.data : []} columns={columns()} options={options} />
        </div>
    );
}

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    data: (state.user &&
        state.user.followers &&
        state.user.followers.data) ? state.user.followers.data : [],
    totalCount: (state.user && state.user.followers &&
        state.user.followers.totalCount) ? state.user.followers.totalCount : 0,
});
const mapDispatchToProps = (dispatch) => ({
    getFollowers: (payload) => dispatch(UserAction.getFollowers(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Followers);

